export default "__VITE_ASSET__BbGk78Ld__"